import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.sqf = bracketIndenting()
